import React from 'react'
import Footer from '../Footer'
import RogerFour from '../RogerFour'


function Roger4() {
    window.scrollTo(0,0);
    return (
        <div>
            <RogerFour/>
            <Footer/>
        </div>
    )
}

export default Roger4
